import type { HTMLAttributes, ReactElement } from 'react';
import type { Offer } from '@/interfaces';

export type OfferRating = Pick<Offer, 'rating'> & {
    bigStars?: boolean;
    emptyStars?: boolean;
    id: string;
} & HTMLAttributes<HTMLDivElement>;

const renderStar = (starType: string, index: number, isBig: boolean): ReactElement => (
    <div className="grid__unit" key={index} data-testid="starRating">
        <div className={`icon ${isBig ? 'bigger-star u-mr2' : 'u-ml2'} ${starType}`} />
    </div>
);

const generateRating = (rating: number, isBig = false, emptyStars = false): ReactElement[] => {
    const intRating: number = Math.floor(rating);
    const isHalf: boolean = rating % 1 === 0.5;
    const ratingsCollection: ReactElement[] = [];
    for (let i = 0; i < intRating; ++i) {
        ratingsCollection.push(renderStar('icon--star-mini', i, isBig));
    }

    if (isHalf) {
        ratingsCollection.push(renderStar('icon--star-mini-half', 10, isBig));
    }

    if (emptyStars) {
        for (let i = intRating + (isHalf ? 1 : 0); i < 5; i++) {
            ratingsCollection.push(renderStar('icon--star-mini-empty', i, isBig));
        }
    }

    return ratingsCollection;
};

export const ImageRating = ({ id, rating, bigStars, emptyStars, className, ...props }: OfferRating) => (
    <div {...props} id={`${id}-Rating`} className={`grid ${className}`}>
        <label htmlFor={`${id}-Rating`} className="u-screen-reader-only">
            {rating} stjerners hotell
        </label>
        {generateRating(rating, bigStars, emptyStars)}
    </div>
);
